export default __webpack_public_path__ + "static/section-5-img-1@2x-bfc3108db869ef6f888f0c1830d74cb5.png";